




























import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class LbzEmptyState extends Vue {
  // on-background (auto-darkened): 'primary', 'secondary', 'surface' (default), 'error', 'light', 'dark'
  @Prop({ type: String, default: '' }) private onBackground!: string;
  // title: '' (default), 'x'
  @Prop({ type: String, default: '' }) private title!: string;
  // subtitle: '' (default), 'x'
  @Prop({ type: String, default: '' }) private subtitle!: string;
}
